if(typeof CartDiscountOption !== 'function') {
    class CartDiscountOption extends HTMLElement {
        constructor() {
            super();

        }

        connectedCallback() {
            const form = this.querySelector('form#cart-discount-form');
            const select = form.querySelector('select#discount-type');
            if(!form) {
                return;
            }
            form.addEventListener('submit', this.onSubmit.bind(this));
            select.addEventListener('change', (event) => {
                const value = event.target.value;
                const cartDiscountCodeInput = form.querySelector('#cart-discount-code');
                if (value === 'code') {
                    cartDiscountCodeInput.placeholder = select.dataset.placeholderCode
                } else if (value === 'giftcard') {
                    cartDiscountCodeInput.placeholder = select.dataset.placeholderGiftCard;
                }
            });
        }

        onSubmit(event) {
            event.preventDefault();
            const form = event.target;
            const formData = new FormData(form);
            const code = formData.get('cart-discount-code');
            const type = formData.get('discount-type');
            if (type === 'code') {
                this.applyDiscountCode(code)
                    .then(response => {
                        if (response.success) {
                        
                            this.showSuccessMessage(response.message);
                        }
                        else {
                            this.showErrorMessage(response.message);
                        }
                    })
                    .catch(error => {
                        console.error('Error applying discount code:', error);
                        this.showErrorMessage('An error occurred while applying the discount code.');
                    });
            } else if (type === 'giftcard') {
                this.applyGiftCardCode(code)
                    .then(response => {
                        if (response.success) {
                            this.showSuccessMessage(response.message);
                        }
                        else {
                            this.showErrorMessage(response.message);
                        }
                    })
                    .catch(error => {
                        console.error('Error applying gift card code:', error);
                        this.showErrorMessage('An error occurred while applying the gift card code.');
                    });
            }
        }
        async applyDiscountCode(code) {
            const url  = window.Shopify.routes.root + 'cart/update.js';
            const body = { discount: code };
          
            const response = await fetch(url, {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify(body)    // stringify impératif :contentReference[oaicite:7]{index=7}
            });
            
            if (!response.ok) {
              const error = await response.json();
              this.showErrorMessage()
              throw new Error(error.description || response.status);
            }
            this.showSuccessMessage();
            return {
              success: true,
              message: 'Discount code applied successfully.'
            };
        }

        async applyGiftCardCode(code) {
            const token = window.KROWN.settings.storefront_api_key;
            const domain = window.KROWN.settings.store_domain;
            const query = `#graphql
                mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
                    cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
                        cart {
                            id
                        }
                        userErrors {
                            field
                            message
                        }
                    }
                }
            `

            const cart = await fetch(window.Shopify.routes.root + "cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "Accept-Control-Allow-Origin": "*",
                },
            });

            if (!cart.ok) {
                this.showErrorMessage();
                throw new Error('Failed to fetch cart ID');
            }
    
            
            const cartData = await cart.json();
            const rawCartId = cartData.token;

            const variables = {
                "cartId": `gid://shopify/Cart/${rawCartId}`,
                "giftCardCodes": [code]
            };
            const response = await fetch(`https://${domain}/api/2025-07/graphql.json`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": token,
                },
                body: JSON.stringify({
                    query: query,
                    variables: variables
                })
            });
            if (!response.ok) {
                const error = await response.json();
                this.showErrorMessage();
                throw new Error(error.errors[0].message || response.status);
            }
            const data = await response.json();
            if (data.data.cartGiftCardCodesUpdate.userErrors.length > 0) {
                const errorMessage = data.data.cartGiftCardCodesUpdate.userErrors[0].message;
                return {
                    success: false,
                    message: errorMessage
                };
            }
            this.showSuccessMessage();
            return {
                success: true,
                message: 'Gift card code applied successfully.'
            };
        }
          

        showSuccessMessage() {
            const successMessage = this.querySelector('.form-success');
            if (successMessage) {
                successMessage.style.display = 'flex';
                setTimeout(() => {
                    window.refreshCart();
                    successMessage.style.display = 'none';
                }, 2000);
            }
        }

        showErrorMessage() {
            const errorMessage = this.querySelector('.form-error');
            if (errorMessage) {
                errorMessage.style.display = 'flex';
                setTimeout(() => {
                    window.refreshCart();
                    errorMessage.style.display = 'none';
                }, 2000);
            }
        }
                    
    }


    customElements.define('cart-discount-option', CartDiscountOption);
}
